module.exports = __webpack_public_path__ + "static/media/capital_60x60.4dc40190.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/capital_60x60.png
// module id = 859
// module chunks = 0